import { observer } from 'mobx-react-lite';
import * as React from 'react';
import loc, { format } from 'owa-localize';
import { getStarted_ProgressBar_Description } from '../getStarted.locstring.json';
import { TaskTallyBannerProperty } from '../interfaces/TaskTallyBannerProperty';
import { getTotalGetStartedTaskCount } from '../selectors/getTotalGetStartedTaskCount';
import { getPendingGetStartedTaskCount } from '../selectors/getPendingGetStartedTaskCount';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import TaskButton from './TaskButton';

export default observer(function TaskTallyBanner(props: TaskTallyBannerProperty) {
    const onClick = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        logUsage('TaskTallyBannerClicked', [props.position], { isCore: true });
        if (props.onClick) {
            props.onClick(evt);
        }
    };
    const totalTaskCount = getTotalGetStartedTaskCount();
    const pendingTaskCount = getPendingGetStartedTaskCount();
    return (
        <TaskButton
            listPosition={props.position}
            visible={true}
            onClick={onClick}
            headIconSection={<Icon iconName={ControlIcons.CheckMark} />}
            buttonTextSection={
                <div>
                    {format(
                        loc(getStarted_ProgressBar_Description),
                        totalTaskCount - pendingTaskCount,
                        totalTaskCount
                    )}
                </div>
            }
        />
    );
});
